const BUBBLE_BLOCKING_OVERLAY_SELECTORS = [
  '.product-info-modal',
  '.mobile-menu-content',
  '.catalog-filter-slideover',
  '.search-panel',
  '.help-slideover',
  '.product-color-slideover',
  '.product-size-slideover',
  '.add-to-cart-modal',
  '.price-history-modal',
  '.info-page-modal',
  '.cart-share-modal',
  '.account-modal',
  '.auth-modal',
  '.cookie-consent-modal',
  '.media-gallery-overlay',
]
const CHAT_BUBBLE_SELECTOR = '#chat-bubble'

// The sticky add-to-cart bar should only push the chat bubble out of the way on
// mobile/tablet (where it's full-width and overlaps the bottom-right bubble). On
// desktop (>= lg) the bar is a centered card and both can coexist.
const STICKY_BAR_SELECTOR = '.sticky-add-to-cart'
const DESKTOP_MIN_WIDTH = 1024

function getChatBubbleIframe(): HTMLIFrameElement | null {
  const chatRoot = document.querySelector(CHAT_BUBBLE_SELECTOR)?.parentElement
  if (!chatRoot) return null

  return [...chatRoot.querySelectorAll('iframe')].find((iframe) => {
    const style = getComputedStyle(iframe)
    return (
      style.display !== 'none' &&
      style.position === 'fixed' &&
      parseInt(style.width, 10) <= 80 &&
      parseInt(style.height, 10) <= 80
    )
  }) ?? null
}

function setImportantStyle(el: HTMLElement, property: string, value: string) {
  if (
    el.style.getPropertyValue(property) === value &&
    el.style.getPropertyPriority(property) === 'important'
  ) {
    return
  }

  el.style.setProperty(property, value, 'important')
}

// tawk's bubble iframe doesn't always carry its own inline `bottom` — its resting
// position can come from an ancestor's containing block instead. Removing our
// override outright can leave it with no usable value, so capture whatever was
// there before we ever touched it and restore exactly that.
let originalBubbleBottom: { value: string; priority: string } | null = null

function syncChatBubble() {
  const overlayBlocking = !!document.querySelector(BUBBLE_BLOCKING_OVERLAY_SELECTORS.join(','))
  const stickyBarBlocking =
    !!document.querySelector(STICKY_BAR_SELECTOR) && window.innerWidth < DESKTOP_MIN_WIDTH
  // const shouldHideBubble = overlayBlocking || stickyBarBlocking
  const shouldHideBubble = overlayBlocking
  const bubble = getChatBubbleIframe()
  if (!bubble) return

  if (originalBubbleBottom === null) {
    originalBubbleBottom = {
      value: bubble.style.getPropertyValue('bottom'),
      priority: bubble.style.getPropertyPriority('bottom'),
    }
  }

  setImportantStyle(bubble, 'visibility', overlayBlocking ? 'hidden' : 'visible')
  setImportantStyle(bubble, 'pointer-events', overlayBlocking ? 'none' : 'auto')

  const stickyBar = window.innerWidth < DESKTOP_MIN_WIDTH ?
                    document.querySelector<HTMLElement>(STICKY_BAR_SELECTOR) : null
  if (stickyBarBlocking) {
    const offset = Math.round(stickyBar.getBoundingClientRect().height) + 24
    setImportantStyle(bubble, 'bottom', `${offset}px`)
  } else if (originalBubbleBottom.value) {
    bubble.style.setProperty('bottom', originalBubbleBottom.value, originalBubbleBottom.priority)
  } else {
    bubble.style.removeProperty('bottom')
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  let observer: MutationObserver | null = null

  nuxtApp.hook('app:mounted', () => {
    observer = new MutationObserver(syncChatBubble)
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style'],
    })

    window.addEventListener('resize', syncChatBubble)
    syncChatBubble()
  })

  nuxtApp.hook('app:beforeUnmount', () => {
    observer?.disconnect()
    observer = null
    window.removeEventListener('resize', syncChatBubble)
  })
})
